import React from 'react'
import FormChaise from '../../../Components/FormChaise'

const AjouterChaise = () => {
  return <FormChaise />
}

export default AjouterChaise
